import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=486bd85d&scoped=true"
import script from "./HeadingBlock.vue?vue&type=script&lang=ts"
export * from "./HeadingBlock.vue?vue&type=script&lang=ts"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=486bd85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486bd85d",
  null
  
)

export default component.exports